import {GenericDgSearchResults} from "./generic.dg-search-results.model";
import {ProductRecommendation} from "../product-recommendation.model";

export class ProductRecommendationDgSearchResults extends GenericDgSearchResults {
  public results: ProductRecommendation[];

  constructor(total: number, results: ProductRecommendation[], csrfToken: string) {
    super();
    this.total = total;
    this.results = results;
    this.csrfToken = csrfToken;
  }
}

